import React, { useEffect, useState } from "react";
import Text from "antd/lib/typography/Text";
import { Image } from "antd";
import styles from "../../styles/dashboard.module.scss";
import EngagementBar from "../../components/EngagementBar";
import StackedBarHappiness from "../../components/StackedBarHappiness";
import { useB2BContext } from "../../context/ContextB2B";
import moment from "moment";
import { authSVC } from "../../services";

export default function Engagement() {
  const { getUserByID } = useB2BContext();

  const [engagementData, setEngagementData] = useState<any[]>([]);
  const [engagementPercentage, setEngagementPercentage] = useState<any>();

  useEffect(() => {
    const year: any = moment().format("yyyy");
    if (getUserByID) {
      authSVC
        .yearlyEngagementIndexes({
          department: "",
          year: Number(year),
          company: getUserByID?.company,
        })
        .then((res) => {
          setEngagementData(res?.data?.data);
          setEngagementPercentage(res?.data);
          console.log(res?.data, "01 000");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [getUserByID]);

  return (
    <div className={styles.white_bg_wrapper}>
      <div className={styles.info_title}>
        <div className="overview-card__header">
          <div className="overview-card__title-row">
            <span
              className="overview-card__dot"
              style={{ background: "#5bbcb0" }}
            />
            <h3 className="overview-card__title">Engagement</h3>
          </div>
          <div className="overview-card__trend">
            <Image src="/figma/up_arrow.svg" preview={false} width={14} />
            <span>{engagementPercentage?.percentage}% from last month</span>
          </div>
        </div>
        <div className={styles.graph}>
          {engagementData?.length === 0 ? (
            <div className="no_data_yet">
              <img src="/img/User_empty.png" alt="" width="56" height="52" />
              <p>No data yet</p>
            </div>
          ) : (
            <EngagementBar chartData={engagementData} />
          )}
        </div>
      </div>
    </div>
  );
}
